import { render, staticRenderFns } from "./SetupCommissionList.vue?vue&type=template&id=06c8e494&"
import script from "./SetupCommissionList.vue?vue&type=script&lang=js&"
export * from "./SetupCommissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports